module.exports = __webpack_public_path__ + "static/media/fly0008.3d6440fd.webp";